let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("56xKj")).then(() => parcelRequire('9NBLG'));